import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import Lenis from 'lenis';
import { gsap, ScrollTrigger } from '../../lib/gsap';

const LenisCtx = createContext(null);

export function useLenis() {
  return useContext(LenisCtx);
}

function SmoothScroll({ children }) {
  const [lenis, setLenis] = useState(null);
  const cleanupRef = useRef(null);

  useEffect(() => {
    const instance = new Lenis({
      autoRaf: false, // Disables built-in RAF loop so GSAP ticker drives Lenis exclusively
      lerp: 0.09,
      wheelMultiplier: 1,
      smoothWheel: true,
      syncTouch: false,
      respectReducedMotion: true,
      autoResize: true,
    });

    instance.on('scroll', ScrollTrigger.update);

    const updateRaf = (time) => {
      instance.raf(time * 1000);
    };

    gsap.ticker.add(updateRaf);
    gsap.ticker.lagSmoothing(0);

    setLenis(instance);

    // Refresh after mount so all pin spacers and scroll lengths are calculated
    const refreshTimer = setTimeout(() => ScrollTrigger.refresh(), 100);

    const onLoad = () => ScrollTrigger.refresh();
    window.addEventListener('load', onLoad);

    cleanupRef.current = () => {
      clearTimeout(refreshTimer);
      instance.destroy();
      gsap.ticker.remove(updateRaf);
      ScrollTrigger.clearScrollMemory();
      window.removeEventListener('load', onLoad);
    };

    return () => {
      if (cleanupRef.current) cleanupRef.current();
    };
  }, []);

  return (
    <LenisCtx.Provider value={lenis}>
      {children}
    </LenisCtx.Provider>
  );
}

export default SmoothScroll;
